export default function(){
  var user;

  return {
    get : function (){
      return user;
    },
    set : function(_user){
      user = _user;
    }
  };
};



// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/services/User.js